(function () {
    'use strict';

    angular
        .module('app')
        .controller('documentgrid', documentgrid);

    documentgrid.$inject = [
        '$location',
        '$scope',
        'gridDataService',
        '$window',
        '$rootScope',
        'columnSetService',
        'sidebarservice',
        '$localStorage',
        '$timeout',
        'uiGridConstants',
        'columnFactory',
        '$filter',
        '$state',
        'libraryService',
        '$mdDialog',
        '$q',
        'loginService',
        'uiGridExporterService',
        'uiGridExporterConstants', 'breadCrumbService', 'workAreaService'];

    function documentgrid(
        $location,
        $scope,
        gridDataService,
        $window,
        $rootScope,
        columnSetService,
        sidebarservice,
        $localStorage,
        $timeout,
        uiGridConstants,
        columnFactory,
        $filter,
        $state,
        libraryService,
        $mdDialog,
        $q,
        loginService,
        uiGridExporterService,
        uiGridExporterConstants, breadCrumbService, workAreaService
        ) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'documentgrid';
        vm.window = $window;
        vm.totalPages = 1;
        vm.columnSetId = 0;
        vm.startRecord = gridDataService.startRecord;
        vm.endRecord = gridDataService.endRecord;
        vm.processing = true;
        vm.initializing = true;
        vm.page = 1;
        vm.pageChanger = 1;
        vm.columnSets = [];
        vm.selectedColumnSet = {};
        vm.sidebarservice = sidebarservice;
        vm.selectAll = false;
        vm.gridSettingsShown = false;
        vm.columnFactory = columnFactory;
        vm.allColumnDefs = [];
        vm.columnsChanged = false;
        vm.showDataCard = false;
        vm.operationTime = "";
        vm.scrollToTop = true;
        vm.columnsWidth = {};
        vm.gridDataService = gridDataService;
        vm.gridDataService.processing = false;
        vm.libraryService = libraryService;
        vm.pageReload = false;
        vm.noRecords = false;
        vm.state = $state;
        vm.paginationSizes = [25, 50, 100, 250, 500, 1000];
        vm.activateCommands = false;
        vm.gridSettingsLoaded = false;
        vm.gridDataService.resizing = false;
        vm.loginService = loginService;
        vm.exportColumns = gridDataService.exportColumns;
        vm.mobile = (bowser.mobile || bowser.tablet) && (bowser.ios || bowser.android);
        vm.breadCrumbService = breadCrumbService;
        vm.workAreaService = workAreaService;
        $scope.selectionState = 2;
        if ($localStorage.userSettings.pageSize && vm.paginationSizes.indexOf(parseInt($localStorage.userSettings.pageSize)) > -1) {
            vm.pageSize = $localStorage.userSettings.pageSize
        }
        else {
            vm.pageSize = 100;
        }

        //initialize localstorage gridstate in case it doesn't exist
        if (!$localStorage["gridState"]) {
            $localStorage["gridState"] = { pageSize: 100, pageNumber: 1 }
        }

        var defaultSort = { sort: "SCHEMA_S_LONGNAME", direction: 0 };
        $localStorage.userSettings.gridSort = $localStorage.userSettings.gridSort == undefined ? defaultSort : $localStorage.userSettings.gridSort;

        //pagination options for the grid
        var paginationOptions = {
            pageNumber: 1,
            pageSize: vm.pageSize,
        };

        vm.rightSideBarServiceToggle = function () {
            sidebarservice.rightSideBarOpen = true;
        };

        //in case data card url was used
        if ($state.current.name == "layout.results.datacard") {
            $state.go('layout.results');
        }

        loginService.log("GRID LOADING");

        //grid options
        vm.gridOptions = {
            enableFullRowSelection: true,
            enableColumnResizing: true,
            paginationPageSizes: vm.paginationSizes,
            paginationPageSize: vm.pageSize,
            useExternalPagination: true,
            multiSelect: true,
            modifierKeysToMultiSelect: true,
            useExternalSorting: true,
            enableRowHeaderSelection: false,
            enablePaginationControls: false,
            enableColumnMenus: false,
            enableSelectionBatchEvent: true,
            minRowsToShow: 30,
            excessRows: 30,
            totalItems: gridDataService.totalRecords,
            flatEntityAccess: true,
            showGridFooter: false,
            data: gridDataService.data,
            columnDefs: gridDataService.columnDefs,
            //handles the register api event
            onRegisterApi: function (gridApi) {
                //grid api object
                vm.gridApi = gridApi;
                //handler for the sort event
                vm.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    sortColumns.sortDirectionCycle = ["asc", "desc"];
                    if ($localStorage.userSettings.gridSort.sort == sortColumns[0].field) {
                        $localStorage.userSettings.gridSort.direction = $localStorage.userSettings.gridSort.direction == 0 ? 1 : 0;
                    }
                    else {
                        $localStorage.userSettings.gridSort = { sort: sortColumns[0].field, direction: 0 };
                    }
                    vm.scrollToTop = false;
                    vm.getPage();
                });
                //pagination event
                vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    paginationOptions.pageNumber = newPage;
                    paginationOptions.pageSize = pageSize;
                    $localStorage.userSettings.pageSize = pageSize;
                    vm.page = newPage;
                    vm.pageChanger = newPage;
                    vm.scrollToTop = true;
                    vm.getPage();
                });

                //handler for the column moved event
                vm.gridApi.colMovable.on.columnPositionChanged($scope, function (colDef, originalPosition, newPosition) {
                    if (vm.gridOptions.columnDefs[0] !== 'GLYPH_TYPE') {
                        vm.gridOptions.columnDefs.splice(newPosition, 0, vm.gridOptions.columnDefs.splice(originalPosition, 1)[0]);
                        var columns = [];

                        vm.processing = true;
                        angular.forEach(vm.gridOptions.columnDefs, function (item, key) {
                            var column = { schemaId: item.field, width: item.width };
                            columns.push(column);
                        });
                        columnSetService.saveColumnSet({ id: vm.columnSetId, columns: columns }).then(function () {
                            vm.processing = false;
                        });
                    }
/*
                    if (vm.gridOptions.columnDefs[0] == 'GLYPH_TYPE') {
                        vm.processing = true;
                        angular.forEach(vm.gridOptions.columnDefs, function (item, key) {
                            var column = { schemaId: item.field, width: item.width };
                            columns.push(column);
                        });
                        columnSetService.saveColumnSet({ id: vm.columnSetId, columns: columns }).then(function () {
                            vm.processing = false;
                        });
                    }
                    else {
                        var columnNumber = 0;
                        angular.forEach(vm.gridOptions.columnDefs, function (item, key) {
                            columnNumber++;
                            var column = { schemaId: item.field, width: item.width };
                            if (column.schemaId == 'GLYPH_TYPE') {
                                vm.gridApi.colMovable.moveColumn(columnNumber, 0);
                            }
                        });
                    }
*/
                });
                //handler for columns resize event
                vm.gridApi.colResizable.on.columnSizeChanged($scope, function (colDef, deltaChange) {
                    var columns = [];
                    vm.scrollToTop = false;
                    var width = 0;

                    if (!vm.columnsWidth[colDef.field]) {
                        vm.columnsWidth[colDef.field] = colDef.width + deltaChange;
                        width = colDef.width + deltaChange;
                    }
                    else {
                        width = vm.columnsWidth[colDef.field] + deltaChange;
                    }

                    //add column to array
                    columns.push({ schemaId: colDef.field, width: width });
                    //set the processing flag
                    vm.processing = true;
                    //resize the columns via the columnset service
                    columnSetService.resizeColumns({ id: vm.columnSetId, columns: columns }).then(function () {
                        $timeout(function () {
                            vm.processing = false;
                        }, 500);
                    });
                });
                
                vm.gridApi.selection.on.rowSelectionChanged($scope, rowSelectionChanged);
                vm.gridApi.selection.on.rowSelectionChangedBatch($scope, rowSelectionChanged);
            }
        };

        vm.exportMenuClicked = function (id) {
            $rootScope.msgBoxShow(loginService.resourceStrings["EXPORT_DATA_STARTED"], loginService.resourceStrings["EXPORT_DATA_TITLE"], 1);
            switch (id) {
                case 1:
                    exportVisibleCsv();
                    break;
                case 2:
                    exportVisibleExcel();
                    break;
                case 3:
                    exportAllCsv();
                    break;
                case 4:
                    exportAllExcel();
                default:
                    break;
            }
        }

        var exportVisibleCsv = function () {
            var pageNumber = paginationOptions.pageNumber;
            var pageSize = paginationOptions.pageSize;
            exportCsv((pageNumber * pageSize) - pageSize, pageSize);
        }

        var exportVisibleExcel = function () {
            var pageNumber = paginationOptions.pageNumber;
            var pageSize = paginationOptions.pageSize;
            exportExcel((pageNumber * pageSize) - pageSize, pageSize);
        }


        var exportAllCsv = function () {
            exportCsv(0, vm.gridOptions.totalItems);
        }

        var exportAllExcel = function () {
            exportExcel(0, vm.gridOptions.totalItems);
        }

        var exportCsv = function (skip, take) {
            var selected = $filter('filter')(vm.exportColumns, { selected: true });
            var columns = [];
            angular.forEach(selected, function (item) {
                columns.push({ schemaId: item.field, width: item.width });
            });

            gridDataService.exportCsv(skip, take, $localStorage.userSettings.gridSort.sort, $localStorage.userSettings.gridSort.direction, columns).then(function (response) {
                processFile(response);
            });
        }

        var exportExcel = function (skip, take) {
            var selected = $filter('filter')(vm.exportColumns, { selected: true });
            var columns = [];
            angular.forEach(selected, function (item) {
                columns.push({ schemaId: item.field, width: item.width });
            });
            gridDataService.exportExcel(skip, take, $localStorage.userSettings.gridSort.sort, $localStorage.userSettings.gridSort.direction, columns).then(function (response) {
                processFile(response);
            });
        }

        var processFile = function (response) {
            var headers = response.headers();
            var data = response.data;
            var filename = headers['x-filename'];
            var contentType = headers['content-type'];

            var blob = new Blob([data], { type: contentType });
            saveAs(blob, filename);
        }

        //row selection event handler
        var rowSelectionChanged = function (row, event) {
            if (!vm.activateCommands) {
                vm.activateCommands = true;
            }

            //array to put the row items
            var selected = [];
            //if the row object is an array iterate over them and find out if any are selected, place them in the array
            if (Object.prototype.toString.call(row) === '[object Array]') {
                angular.forEach(row, function (item) {
                    if (item.isSelected) {
                        selected.push(item);
                    }
                });
            }
                //single item
            else {
                if (row.isSelected) {
                    selected.push(row);
                }
            }

            //if items were selected, set the focus to the main grid and call the record selected method in the service.
            gridDataService.currentFocus = "main";
            gridDataService.recordSelected(vm.gridApi.selection.getSelectedRows());
            console.log("Number of records selected:", vm.gridApi.selection.getSelectedRows().length);
            //gridDataService.selectedRows = vm.gridApi.selection.getSelectedRows();
            vm.selectAll = gridDataService.selectedRows.length == 0 ? false : true;

            if (vm.gridApi.selection.getSelectedRows().length == 0) {
                $scope.selectionState = 2;
            }
            else if (vm.gridApi.selection.getSelectedRows().length == vm.gridOptions.data.length) {
                $scope.selectionState = 1;
            }
            else {
                $scope.selectionState = 0;
            }       
        };

        //triggers the grid's handleWindowResize method when the sidebar menu is opened or closed.
        $rootScope.$on('sidebar-button:clicked', function () {
            gridRefresh();
        });

        $scope.$watch(function () {
            return sidebarservice.rightSideBarOpen;
        }, function () {
            $timeout(function () {
                gridRefresh();
                if (vm.toolbar.accessor.calculateSize)
                    $timeout(function () {
                        vm.toolbar.accessor.calculateSize();
                    }, 500);
            }, 1);

        })

        //method to obtain a new page
        vm.getPage = function (reset) {
            var deferred = $q.defer();
            if (vm.gridApi) {
                vm.gridApi.selection.clearSelectedRows();
            }            
            vm.processing = true;
            vm.noRecords = false;
            vm.gridOptions.data.length = 0;
            if (gridDataService.serviceIdentifier == "") {
                //it's a page reload
                vm.pageReload = true;
                if (!$localStorage.userSettings["gridState"]) {
                    return $state.go('layout.home')
                }
                gridDataService.serviceIdentifier = $localStorage.userSettings["lastGridService"];
                paginationOptions.pageNumber = $localStorage.userSettings["gridState"]["pageNumber"];
                paginationOptions.pageSize = $localStorage.userSettings["gridState"]["pageSize"];
                vm.gridOptions.paginationCurrentPage = paginationOptions.pageNumber;
            }

            gridDataService.data = [];
            gridDataService.processing = true;
            //get current column sets
            columnSetService.getColumnSets(true).then(function (response) {
                vm.columnSets = response.data;
                var pageNumber = paginationOptions.pageNumber;
                var pageSize = paginationOptions.pageSize;
                vm.noRecords = false;
                var results;
                try {
                    gridDataService.getData((pageNumber * pageSize) - pageSize, pageSize, $localStorage.userSettings.gridSort.sort, $localStorage.userSettings.gridSort.direction)
                        .then(function (response) {
                            vm.showDataCard = false;

                            $localStorage.userSettings["lastGridService"] = gridDataService.serviceIdentifier;
                            gridDataService.selectedRows = [];
                            if (response.data.AdeptDataTable.TableRecords.length == 0) {
                                //vm.gridOptions.data = 
                                vm.processing = false;
                                vm.startRecord = 0;
                                vm.endRecord = 0;
                                vm.gridDataService.startRecord = 0;
                                vm.gridOptions.totalItems = 0;
                                vm.totalPages = 0;
                                vm.columnSetId = columnSetService.currentColumnSet;
                                vm.gridOptions.data = gridDataService.data;
                                $rootScope.$broadcast('grid:data-loaded');
                                $localStorage.userSettings.gridState = {
                                    totalItems: vm.gridOptions.totalItems,
                                    serviceIdentifier: gridDataService.serviceIdentifier,
                                    pageNumber: pageNumber,
                                    pageSize: pageSize
                                }
                                $timeout(function () {
                                    vm.noRecords = true;
                                }, 100);
                                return;

                            };

                            vm.operationTime = response.data.OperationTime;

                            results = response;
                            columnSetService.fieldDefinitions = results.data.AdeptDataTable.TableDefinition.fldDefList;

                            vm.columnSetId = columnSetService.currentColumnSet;
                            if (vm.columnSetId == "") {
                                vm.columnSetId = response.data.ColumnSetId;
                            }
                            $localStorage.userSettings["columnSetId"] = vm.columnSetId;

                            //glyphs 
                            angular.forEach(results.data.AdeptDataTable.TableRecords, function (row) {
                                var glyphType = row["GLYPHTYPE"];
                                var glyphMap = results.data.AdeptDataTable.GlyphMap;
                                var glyph = glyphMap[glyphType];
                                if (glyph)
                                    row.GLYPH_TYPE = glyph.replace("image;base64,", "image/bmp;base64,");
                                else
                                    row.GLYPH_TYPE = "";
                            });


                            columnSetService.getColumnSetColumns(vm.columnSetId, true).then(function (response) {
                                var columnDefs = [];

                                if (response.data.length == 0) {
                                    response.data = [];
                                    response.data.push({ schemaId: "SCHEMA_S_LONGNAME", width: 250, pinnedLeft: false });
                                    response.data.push({ schemaId: "SCHEMA_S_STATUS", width: 100 });
                                    response.data.push({ schemaId: "SCHEMA_S_LIBNAME", width: 350 });
                                    response.data.push({ schemaId: "SCHEMA_S_OWNER", width: 200 });
                                }

                                var glyphColumn = {
                                    name: "",
                                    field: "GLYPH_TYPE",
                                    width: "30",
                                    enableSorting: false,
                                    enableColumnMoving: false,
                                    minWidth: "30",
                                    maxWidth: "30",
                                    cellTemplate: "<img width=\"25px\" height=\"17px\" ng-src=\"{{grid.getCellValue(row, col)}}\" lazy-src>",
                                    pinnedLeft: true
                                };

                                columnDefs.push(glyphColumn);
                               
                                angular.forEach(response.data, function (item, key) {
                                    try {
                                        var enableSorting = true;
                                        if (item.schemaId == "SCHEMA_S_VERSION") {
                                            enableSorting = false;
                                        }
                                        var column = {
                                            name: results.data.AdeptDataTable.TableDefinition.fldDefList[item.schemaId].displayName,
                                            field: item.schemaId,
                                            width: item.width,
                                            enableSorting: enableSorting,
                                            cellClass: function (grid, row, col, rowRenderIndex, colRenderIndex) {
                                                if (row.entity["SCHEMA_S_LINKED"] != "L") {
                                                    return "italic";
                                                }
                                            },
                                            bSystem: results.data.AdeptDataTable.TableDefinition.fldDefList[item.schemaId].bSystem,
                                            //cellTemplate: '<div class="ui-grid-cell-contents" title="TOOLTIP" ng-mouseover="grid.appScope.showStuff($event, row, grid)">{{COL_FIELD CUSTOM_FILTERS}}</div></div>'
                                        }
                                        //sort
                                        if (item.schemaId == $localStorage.userSettings.gridSort.sort) {
                                            var direction = $localStorage.userSettings.gridSort.direction == 0 ? uiGridConstants.ASC : uiGridConstants.DESC;
                                            column.sort = {
                                                direction: direction,
                                                priority: null
                                            }
                                        }
                                        column.sortDirectionCycle = ["asc", "desc"];
                                        columnDefs.push(column);
                                        console.log(column);

                                    } catch (e) {
                                        loginService.log("Unable to add column " + item.schemaId + " due to: " + e);
                                    }
                                });
                                vm.gridOptions.columnDefs = [];
                                vm.gridOptions.data = [];



                                $timeout(function () {
                                    vm.gridOptions.columnDefs = angular.copy(columnDefs);
                                    //Bug fix 
                                    vm.exportColumns = $filter('filter')(angular.copy(columnDefs), { name: "!" }, true); 
                                    console.log("Export columns", vm.exportColumns);
                                    gridDataService.exportColumns = vm.exportColumns;
                                    gridDataService.columnDefs = columnDefs;
                                    vm.gridApi.grid.notifyDataChange(uiGridConstants.dataChange.ALL);
                                    angular.forEach(vm.exportColumns, function (item) {
                                        item.selected = true;
                                    });
                                    vm.gridOptions.data = gridDataService.data;
                                    vm.processing = false;

                                    $localStorage.userSettings.gridState = {
                                        totalItems: vm.gridOptions.totalItems,
                                        serviceIdentifier: gridDataService.serviceIdentifier,
                                        pageNumber: pageNumber,
                                        pageSize: pageSize
                                    }


                                    //broadcast that the grid is finished loading data
                                    $rootScope.$broadcast('grid:data-loaded');

                                    //scroll to top if needed
                                    if (vm.scrollToTop) {
                                        vm.gridApi.grid.element[0].getElementsByClassName("ui-grid-viewport")[0].scrollTop = 0;
                                    }
                                    vm.scrollToTop = true;
                                    //refresh the grid
                                    if (bowser.firefox) {
                                        $timeout(function () {
                                            vm.gridApi.grid.element[0].getElementsByClassName("ui-grid-viewport")[0].scrollTop = 1;
                                            $timeout(function () {
                                                vm.gridApi.grid.element[0].getElementsByClassName("ui-grid-viewport")[0].scrollTop = 0;

                                            }, 500);
                                        }, 500);
                                    }                                  
                                    gridRefresh();
                                });
                                
                                

                            }, function (error) {


                                vm.processing = false;
                                vm.showDataCard = false;
                                gridDataService.selectedRows = [];
                                $rootScope.$broadcast('grid:data-loaded');
                                loginService.log(error);
                                deferred.reject();
                            });

                            vm.noRecords = false;
                            gridDataService.getCount().then(function (totalRecords) {
                                vm.startRecord = (pageNumber * pageSize) - pageSize + 1;
                                gridDataService.startRecord = vm.startRecord;
                                
                                /*
                                if (pageNumber * pageSize > totalRecords) {
                                    if ( pageNumber > 1 )
                                    {
                                        vm.endRecord = (pageNumber * pageSize) - pageSize + totalRecords;
                                    }
                                    else {
                                        vm.endRecord = totalRecords;
                                    }
                                }
                                else {
                                    vm.endRecord = pageNumber * pageSize;
                                }
                                */
                                vm.endRecord = (pageNumber * pageSize) > totalRecords ? totalRecords : (pageNumber * pageSize);
                                vm.gridDataService.endRecord = vm.endRecord;
                                vm.gridOptions.totalItems = totalRecords;
                                vm.totalPages = vm.gridApi.pagination.getTotalPages();
                                gridDataService.currentPage = vm.currentPage;
                                gridDataService.totalPages = vm.totalPages;
                            });


                            deferred.resolve();
                        }, function (error) {
                            //.noRecords = true;
                            vm.processing = false;
                            vm.showDataCard = false;
                            gridDataService.selectedRows = [];
                            $rootScope.$broadcast('grid:data-loaded');
                            loginService.log(error);
                            deferred.reject();
                        });



                } catch (e) {

                }
                var popupTimeout = {};
                vm.popupActionPosition = {};
                vm.popupActionShown = false;
                $scope.showStuff = function (event, row, grid) {
                    //vm.popupActionShown = false;
                    //var ev = event;
                    //var selectedRows = vm.gridApi.selection.getSelectedRows();
                    //vm.popupActionPosition = { x: event.target.clientX, y: event.target.clientY }
                    //if (selectedRows.length > 0) {
                    //    $timeout.cancel(popupTimeout);
                    //    popupTimeout = $timeout(function () {
                    //        vm.popupActionShown = true;
                    //        console.log(ev);
                    //        console.log(row);
                    //        console.log("popup shown")
                    //    }, 500);
                    //}
                }





                //services to skip count
                //if ((pageNumber == 1 || vm.pageReload) && noCountServices.indexOf(gridDataService.serviceIdentifier) == -1 && gridDataService.totalRecords == 0) {
                //    gridDataService.countRecords().then(function (totalRecords) {
                //        vm.startRecord = (pageNumber * pageSize) - pageSize + 1;
                //        vm.endRecord = (pageNumber * pageSize) > gridDataService.totalRecords ? gridDataService.totalRecords : (pageNumber * pageSize);
                //        vm.gridOptions.totalItems = gridDataService.totalRecords;
                //        vm.totalPages = vm.gridApi.pagination.getTotalPages();
                //        vm.pageReload = false;
                //    })
                //}
                //else {
                //    vm.startRecord = (pageNumber * pageSize) - pageSize + 1;
                //    vm.endRecord = (pageNumber * pageSize) > gridDataService.totalRecords ? gridDataService.totalRecords : (pageNumber * pageSize);
                //}

            });

            return deferred.promise;
        };

        $scope.selectAllClicked = function () {
            if (vm.gridApi.selection.getSelectedRows().length == 0) {
                vm.gridApi.selection.selectAllRows();
                $scope.selectionState = 1;
            }
            else {
                vm.gridApi.selection.clearSelectedRows();
                $scope.selectionState = 2;
            }

            loginService.log("select all");
        }

        //handles the event emitted by the page selector
        vm.pageChange = function (page) {
            vm.scrollToTop = false;
            if (page != "") {
                vm.page = page;
                if (vm.page <= vm.totalPages && vm.page !== null) {
                    vm.gridApi.pagination.seek(parseInt(vm.page));
                }
                else {
                    vm.page = vm.gridApi.pagination.getPage();
                }
            }
            else {
                vm.pageChanger = vm.page;
            }
            
        };

        //grid reload
        gridDataService.reloadGrid = function () {
            loginService.log("GRID RELOAD");
            gridDataService.data = [];
            vm.scrollToTop = true;
            vm.selectAll = false;
            gridDataService.totalRecords = 0;
            gridDataService.data = [];
            if (vm.page == 1) {
                vm.getPage(true);
            }
            else {
                vm.gridApi.pagination.seek(1);
            }
        }

        //
        vm.toggleGridSettings = function () {
            vm.gridSettingsLoaded = true;
            //if the array contains no columns initialize it
            if (vm.allColumnDefs.length == 0) {
                //check which columns are in use and add it to the list if it's not
                columnFactory.getAvailableColumns().then(function (response) {
                    angular.forEach(response.data, function (item, key) {
                        var found = $filter('filter')(vm.gridOptions.columnDefs, { field: item.schemaID }, true);
                        if (found.length == 0) {
                            // System field
                            //Not the proper way to set styles
                            //if (item.bSystem == false ) {
                            //    var itemStyle = "background-color: #FFAC47";
                            //}
                            vm.allColumnDefs.push({ field: item.schemaID, name: item.displayName, width: 200, bSystem: item.bSystem });
                        }
                    });
                }); 
            };

            //make a copy of the current and all grid columnDefs
            vm.gridColumnDefsCopy = angular.copy(vm.gridOptions.columnDefs);
            vm.allColumnDefsCopy = angular.copy(vm.allColumnDefs);

            loginService.log("Grid Columns");
            loginService.log(vm.gridOptions.columnDefs);
            loginService.log("All Columns");
            loginService.log(vm.allColumnDefs);


            vm.gridSettingsShown = !vm.gridSettingsShown;
        };

        gridDataService.onSelectedRecordChanged = function (records, justClear) {
            vm.gridApi.selection.clearSelectedRows();
            //bypass record selection if the call is just to clear the grid's selection
            if (!justClear) {
                vm.gridApi.selection.selectRow(records);
            }
        }

        gridDataService.onRecordCountsChanged = function () {
            vm.startRecord = gridDataService.startRecord;
            vm.endRecord = gridDataService.endRecord;
            vm.gridOptions.totalItems = gridDataService.totalRecords;
            vm.noRecords = gridDataService.totalRecords === 0;

            if (vm.noRecords) {
                vm.gridApi.selection.clearSelectedRows();
            }
        }

        //this will ensure we remeber the scroll position
        var scrollPosition = 0;
        $rootScope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {
            if (toState.name != 'layout.results.grid') {
                if (vm.gridApi) {
                    scrollPosition = vm.gridApi.grid.element[0].getElementsByClassName("ui-grid-viewport")[0].scrollTop;
                }                
            }
            else {
                if (vm.toolbar.accessor.calculateSize)
                    $timeout(function () {
                        vm.toolbar.accessor.calculateSize();
                    }, 1000);
            }
            $timeout(function () {
                vm.gridApi.grid.element[0].getElementsByClassName("ui-grid-viewport")[0].scrollTop = scrollPosition;
                gridRefresh();
            }, 400);
            gridRefresh();
        });

        //this will set the initial state of the fileguide to collapsed
        $timeout(function () {
            vm.sidebarservice.fileGuideCollapse = true;
        });

        //refresh the grid when the fileguide is expanded or collapsed.
        $scope.$watch(function () {
            return vm.sidebarservice.fileGuideCollapse;
        }, function (value) {
            $timeout(function () {
                gridRefresh();
            })
        });

        $scope.$watch(function () {
            return vm.sidebarservice.rightSideBarOpen;
        }, function () {
            gridRefresh();
        })

        gridDataService.gridRefresh = function () {
            gridRefresh();
        }

        //removes the file guide from the grid area and puts it back on the sidebar
        vm.hideFileGuide = function () {
            sidebarservice.showDataToolBox = true;
            sidebarservice.fileGuideCollapse = true;
            libraryService.resetFilter();
            $timeout(function () {
                gridRefresh();
            });
        }

        //removes the file guide from the grid area.
        vm.closeFileGuide = function () {
            sidebarservice.fileGuideCollapse = true;
            libraryService.resetFilter();
            $timeout(function () {
                gridRefresh();
            });
        }

        //get the tree for the fileguide.
        vm.libraryService.getTree().then(function (tree) {
            vm.libraryTree = tree;
        });

        //this method will handle all the ways to refresh/redraw the grid
        var gridRefresh = function () {
            vm.gridApi.grid.handleWindowResize();
            vm.gridApi.grid.refreshCanvas();
            vm.gridApi.grid.refresh();
            $timeout(function () {
                vm.gridApi.grid.handleWindowResize();
                vm.gridApi.grid.refreshCanvas();
                vm.gridApi.grid.refresh();
            }, 50);
            $timeout(function () {
                vm.gridApi.grid.handleWindowResize();
                vm.gridApi.grid.refreshCanvas();
                vm.gridApi.grid.refresh();
            }, 100);
            $timeout(function () {
                vm.gridApi.grid.handleWindowResize();
                vm.gridApi.grid.refreshCanvas();
                vm.gridApi.grid.refresh();
            }, 500);
            $timeout(function () {
                vm.gridApi.grid.handleWindowResize();
                vm.gridApi.grid.refreshCanvas();
                vm.gridApi.grid.refresh();
            }, 1000);
        }

        vm.fileGuideItemClicked = function (item) {

        }

        var uploadDialog = function (scope) {
            scope.onOK = function () {
                $mdDialog.hide();
            }
            scope.onCancel = function () {
                $mdDialog.cancel();
            }
        }

        vm.uploadButtonClicked = function () {
            $mdDialog.show({
                controller: uploadDialog,
                templateUrl: "app/checkin/templates/UploadDialog.html",
                clickOutsideToClose: false,
                fullscreen: false,
                parent: angular.element(document.body)
            })
        }

        //when a record is updated we will unselect it and reselect it.
        gridDataService.registerOnUpdateRecords(function (record) {
            if (record.SCHEMA_S_FILEID) {
                var selectedRecords = vm.gridApi.selection.getSelectedRows();
                $timeout(function () {
                    if (selectedRecords.length > 0) {
                        vm.gridApi.selection.selectRow(record);
                    }
                }, 50);
            }
        });

        //toolbar accessor, directive methods can be called thru it.
        function toolbar() { return { accessor: {} }; }

        vm.toolbar = new toolbar;

        //activate
        activate();

        function activate() {
            //initial page load
            if ($state.current.name == "layout.results.grid") {
                return vm.getPage();
            }
        }

        vm.paneResize = function () {
            gridRefresh();
        }

        vm.containerHeight = 350;
        $scope.$on("dd:resize", function (event, size) {
            vm.containerHeight = parseInt(size.topHeight);
            if (!$scope.$$phase) {
                $scope.$apply();
            }
            $timeout(function () {
                gridRefresh();
            });
            $timeout(function () {
                var scrollPos = vm.gridApi.grid.element[0].getElementsByClassName("ui-grid-viewport")[0].scrollTop;
                vm.gridApi.grid.element[0].getElementsByClassName("ui-grid-viewport")[0].scrollTop = scrollPos - 2;
            }, 2000);
        });

        $scope.$on('$destroy', function () {
            loginService.log("DESTROY GRID");
        });

        gridDataService.refreshGrid = function () {
            gridRefresh();
        }

        vm.gridRefresh = function () {
            gridRefresh();
        }
    }
})();

